import { Nominal } from "@goodfill/nominal";

export type OrderTicketId = Nominal<"OrderTicketId">;
export const asOrderTicketId = (id: string) => id as unknown as OrderTicketId;

export enum OrderDirection {
  Buy = "Buy",
  Sell = "Sell",
}

export enum OrderStatus {
  Open = "Open",
  WaitingForTrader = "WaitingForTrader",
  Canceled = "Canceled",
  Closed = "Closed",
  CanceledByCustomer = "CanceledByCustomer",
  CanceledByTrader = "CanceledByTrader",
  CanceledAndReplaced = "CanceledAndReplaced",
  PendingCancelApproval = "PendingCancelApproval",
  PendingModifyApproval = "PendingModifyApproval",
  FillSubmittedToBroker = "FillSubmittedToBroker",
  FillAcknowledgedByBroker = "FillAcknowledgedByBroker",
  CancelSubmittedToBroker = "CancelSubmittedToBroker",
  ModifySubmittedToBroker = "ModifySubmittedToBroker",
  FullyFilled = "FullyFilled",
  Expired = "Expired",
}

export const ORDER_STATUSES = [
  OrderStatus.Open,
  OrderStatus.WaitingForTrader,
  OrderStatus.Canceled,
  OrderStatus.Closed,
  OrderStatus.CanceledByCustomer,
  OrderStatus.CanceledByTrader,
  OrderStatus.CanceledAndReplaced,
  OrderStatus.PendingCancelApproval,
  OrderStatus.PendingModifyApproval,
  OrderStatus.FillSubmittedToBroker,
  OrderStatus.FillAcknowledgedByBroker,
  OrderStatus.CancelSubmittedToBroker,
  OrderStatus.ModifySubmittedToBroker,
  OrderStatus.FullyFilled,
  OrderStatus.Expired,
];

export enum TimeInForce {
  CustomToday = "CustomToday",
  Immediate = "Immediate",
  CustomFuture = "CustomFuture",
}
